"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIconFontSize = void 0;
var iconSizes = {
    xl: 40,
    l: 32,
    m: 24,
    s: 16,
    xs: 12,
};
var getIconFontSize = function (size) {
    return iconSizes[size];
};
exports.getIconFontSize = getIconFontSize;
